import {HttpEvent, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SKIP_AUTH} from '../_utils/skip-auth.token';
import {environment} from "../../environments/environment";

export const headersInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<unknown>> => {

    const isUrlWhitelisted: boolean = environment.whitelist.some(url => request.url.includes(url));

    // Uses .some() to check if the request URL includes any string from the whitelist array
    if (request.context.get(SKIP_AUTH) || !isUrlWhitelisted) {
        return next(request);
    }

    const sessionToken: string | null = localStorage.getItem('session_token');
    const accessToken: string | null = localStorage.getItem('access_token');
    const headerMap: Record<string, string> = {};

    if (sessionToken) {
        headerMap['X-Session-Token'] = sessionToken;
    }

    if (accessToken) {
        headerMap['Authorization'] = `Bearer ${accessToken}`;
    }

    const modifiedRequest: HttpRequest<unknown> = request.clone({
        setHeaders: headerMap
    });

    return next(modifiedRequest);
};
